// v2/hooks/useAdminCustomer.js — musteri detayi, hareketler ve kullanici islemleri
import { useCallback, useEffect, useRef, useState } from 'react';
import { apiGet, apiPost, qs } from '../utils/api';

/** Musteri kunyesi + kullanicilar + son siparis/giris */
export function useAdminCustomer(kod) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);

  const yenile = useCallback(async () => {
    if (!kod) return;
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;
    setLoading(true);
    setError(null);
    try {
      const veri = await apiGet(`/v2/admin/customers/${encodeURIComponent(kod)}/`, { signal: ctrl.signal });
      if (ctrl.signal.aborted) return;
      if (!veri || !veri.success) throw new Error((veri && veri.message) || 'Müşteri alınamadı');
      setData({
        ...veri,
        users: Array.isArray(veri.users) ? veri.users : [],
        recent_orders: Array.isArray(veri.recent_orders) ? veri.recent_orders : [],
        recent_logins: Array.isArray(veri.recent_logins) ? veri.recent_logins : [],
      });
    } catch (e) {
      if (e && e.name === 'AbortError') return;
      setError((e && e.message) || 'Müşteri alınamadı');
    } finally {
      if (!ctrl.signal.aborted) setLoading(false);
    }
  }, [kod]);

  useEffect(() => {
    yenile();
    return () => { if (abortRef.current) abortRef.current.abort(); };
  }, [yenile]);

  return { data, loading, error, yenile };
}

/** Cari hesap hareketleri (sayfali) */
export function useAdminTransactions(kod, params, etkin = true) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);
  const sorgu = qs(params);

  useEffect(() => {
    if (!kod || !etkin) return undefined;
    const ctrl = new AbortController();
    abortRef.current = ctrl;
    setLoading(true);
    setError(null);
    apiGet(`/v2/admin/customers/${encodeURIComponent(kod)}/transactions/${sorgu}`, { signal: ctrl.signal })
      .then((veri) => {
        if (ctrl.signal.aborted) return;
        if (!veri || !veri.success) throw new Error((veri && veri.message) || 'Hareketler alınamadı');
        setData({ ...veri, items: Array.isArray(veri.items) ? veri.items : [] });
      })
      .catch((e) => {
        if (ctrl.signal.aborted || (e && e.name === 'AbortError')) return;
        setError((e && e.message) || 'Hareketler alınamadı');
      })
      .finally(() => { if (!ctrl.signal.aborted) setLoading(false); });
    return () => ctrl.abort();
  }, [kod, sorgu, etkin]);

  return { data, loading, error };
}

/** Kullanici islemleri — hepsi hata firlatir, cagiran yakalar */
export const adminUserApi = {
  ekle: (kod, govde) =>
    apiPost(`/v2/admin/customers/${encodeURIComponent(kod)}/users/`, govde),
  guncelle: (id, govde) => apiPost(`/v2/admin/users/${id}/update/`, govde),
  sil: (id) => apiPost(`/v2/admin/users/${id}/delete/`, { confirm: true }),
  parola: (id) => apiGet(`/v2/admin/users/${id}/password/`),
  parolaOner: () => apiGet('/v2/admin/password-suggest/'),
};
